import React, { useState, useEffect } from 'react';
import { Bot } from 'lucide-react';
import { Theme } from '../types';

interface LoadingIndicatorProps {
  theme: Theme;
  status?: string;
}

export function LoadingIndicator({status}: LoadingIndicatorProps) {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const currentTime = Date.now();
      const elapsed = Math.floor((currentTime - startTime) / 1000); // Convert to whole seconds
      setElapsedTime(elapsed);
    }, 1000); // Update every second since we only need whole seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="py-6 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-3xl mx-auto flex gap-4 px-4">
        <div className="mt-1">
          <Bot className="w-6 h-6 text-blue-600" />
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce [animation-duration:1s] [animation-delay:-0.3s]"></div>
            <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce [animation-duration:1s] [animation-delay:-0.15s]"></div>
            <div className="w-1.5 h-1.5 bg-blue-600 rounded-full animate-bounce [animation-duration:1s]"></div>
          </div>
          <div className="flex items-center gap-2">
            <div className="text-sm text-gray-500 dark:text-gray-400">
              {elapsedTime}s
            </div>
            {status && (
              <div className="text-sm text-gray-700 dark:text-gray-300">
                {status}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
